import React from 'react';
import { fonts } from './../../styles/theme.json';

export default (props) => (
  <button className="video__player-button" onClick={props.PlayFunction}>
    <svg className="play-svg" version="1.1" viewBox="0 0 64 64" width="64" height="64">
      <g className="play-wrapper">
        <path className="play-path" d="M13.593,3.195c-0.303-0.224-0.708-0.257-1.044-0.087C12.212,3.278,12,3.623,12,4v56 c0,0.377,0.212,0.722,0.549,0.893C12.691,60.964,12.846,61,13,61c0.21,0,0.418-0.066,0.593-0.195l38-28 C51.849,32.617,52,32.318,52,32s-0.151-0.617-0.407-0.805L13.593,3.195z"></path>
      </g>
    </svg>
    {(props.CTA) && <span className='cta'>{props.CTA}</span>}
    <style jsx>{`
      .video__player-button {
        width: 64px;
        height: 50px;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        z-index: 1000;
        -webkit-tap-highlight-color: rgba(255,255,255,0);
        border: 0;
        background: rgba(255,255,255,0);
        border-radius: 0,
        appearance: none;
        cursor: pointer;
        will-change: opacity;
        transition: opacity 250ms ease;
        opacity: 1;
      }
      .cta {
        font-family: ${fonts.mallory};
        font-size: ${fonts.caption_size};
        font-weight: 700;
        color: #fff;
        letter-spacing: .1rem;
        text-align: center;
        text-transform: uppercase;
        width: 100%;
        padding-top: 5px;
      }
      .video__player-button:hover {
        opacity: .5;
      }
      .play-svg {
        display: block;
        position: relative;
        margin: auto;
        width: 100%;
        height: 100%;
      }
      .nc-icon-wrapper {
        fill: rgba(255,255,255,0.85);
      }
      .play-path {
        fill: rgba(255,255,255,0.85);
      }
    `}</style>
  </button>
);



// WEBPACK FOOTER //
// ./src/components/video-player/PlayButton.js